<div *ngIf="platform === 'ios'" class="ion-activatable" ion-activatable>
    <ion-ripple-effect class="arrow-ripple-effect-ios"></ion-ripple-effect>
    <ion-icon name="chevron-back" class="chevron-back" (click)="navigateBack()"></ion-icon>
</div>
<div *ngIf="platform === 'android'" class="ion-activatable" ion-activatable>
    <ion-ripple-effect class="arrow-ripple-effect-md"></ion-ripple-effect>
    <ion-icon name="chevron-back" class="chevron-back" (click)="navigateBack()"></ion-icon>
</div>
